import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Button as ToolboxButton } from 'react-toolbox/lib/button'

import styles from './Button.scss'

const Button = ({
  buttonType, children, className, disabled, openInNewWindow, type, mini, show, ...rest
}) => {
  const toolBoxProps = {
    className: classnames(styles.base, {
      [styles.disabled]: disabled,
      [styles.flat]: type === 'flat',
      [styles.primary]: type === 'primary',
      [styles.secondary]: type === 'secondary',
      [styles.mini]: mini === true,
      [styles.hide]: !show,
    }, className),
    disabled,
    flat: type === 'flat',
    primary: type === 'primary',
    raised: type !== 'flat',
    target: openInNewWindow ? '_blank' : '_self',
    type: buttonType,
  }

  return (
    <ToolboxButton {...toolBoxProps} {...rest}>
      {children}
    </ToolboxButton>
  )
}

Button.propTypes = {
  buttonType: PropTypes.oneOf([
    'button',
    'submit',
    'reset',
    'menu',
  ]),
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  show: PropTypes.bool,
  type: PropTypes.string,
  mini: PropTypes.bool,
}

Button.defaultProps = {
  buttonType: 'button',
  type: 'primary',
  show: true,
  mini: false,
  disabled: false,
  className: null,
  children: null,
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/Button.js